export const choosing_supplement_bwc = [
    {
        Xpos_text: 25,
        Ypos_text: 100,
        // page_eng: 15,
        // page_thai: 14,
        info: [
            {sp: 'Bifidobacterium bifidum', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium breve', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium lactis', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium longum', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus acidophilus', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus gasseri', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus helveticus', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus paracasei', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus plantarum', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus reuteri', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus rhamnosus', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Streptococcus thermophilus', less: ['Deficient', 'Slightly Deficient']},
        ]
    }
]

export const supplement_bacteria_map_bwc = {
    'Pro 4': {
      'Bifidobacterium bifidum': 10,
      'Bifidobacterium breve': 10,
      'Lactobacillus rhamnosus': 10
    },
    'Pro 6': {
        'Bifidobacterium bifidum': 10,
        'Lactobacillus acidophilus': 10,
        'Lactobacillus rhamnosus': 10,
        'Bifidobacterium lactis': 10,
        'Bifidobacterium longum': 10,
        'Lactobacillus paracasei': 10
    }
};

export const supplement_images_bwcdiamond_eng = {
    'Pro 4': {
        image_name: 'pro-4',
        // page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },
    'Pro 6': {
        image_name: 'pro-6',
        // page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    }
};

export const supplement_images_bwcdiamond_thai = {
    'Pro 4': {
        image_name: 'pro-4',
        // page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    },
    'Pro 6': {
        image_name: 'pro-6',
        // page: 31,
        x: 160,
        y: 560,
        width: 745,
        height: 'auto'
    }
};

export const choosing_supplement_bwcdiamond = [
    {
        Xpos_text: 25,
        Ypos_text: 100,
        // page_eng: 15,
        // page_thai: 14,
        info: [
            {sp: 'Bifidobacterium bifidum', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium breve', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium lactis', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Bifidobacterium longum', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus acidophilus', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus gasseri', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus helveticus', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus paracasei', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus plantarum', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus reuteri', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Lactobacillus rhamnosus', less: ['Deficient', 'Slightly Deficient']},
            {sp: 'Streptococcus thermophilus', less: ['Deficient', 'Slightly Deficient']},
        ]
    }
]

export const supplement_bacteria_map_bwcdiamond = {
    'Pro 4': {
      'Bifidobacterium bifidum': 10,
      'Bifidobacterium breve': 10,
      'Lactobacillus rhamnosus': 10
    },
    'Pro 6': {
        'Bifidobacterium bifidum': 10,
        'Bifidobacterium lactis': 10,
        'Bifidobacterium longum': 10,
        'Lactobacillus acidophilus': 10,
        'Lactobacillus paracasei': 10,
        'Lactobacillus rhamnosus': 10,
    }
};